<div>
    <div fxLayout="row wrap" fxLayoutAlign="center" fxFlex="100">
      <div fxLayoutAlign="center"  class="ps-form-container">
        <object width="100%" height="2000px" [data]="reportUrl" type="application/pdf">
          <embed width="100%" height="2000px" [src]="reportUrl" type="application/pdf" />
        </object>
      </div>
    </div>
</div>
